import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProductService } from '@features/product/services/product.service';
import { combineLatest, map, mergeMap, Subject, takeUntil } from 'rxjs';
import { LayoutService } from 'src/app/layout/services/layout.service';
@Component({
  selector: 'fc-user-wishlist',
  templateUrl: './user-wishlist.component.html',
  styleUrls: ['./user-wishlist.component.css'],
})
export class UserWishlistComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  wishListProduct: any;
  loading: boolean = true;

  constructor(
    private productService: ProductService,
    private layoutService: LayoutService
  ) {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          title: 'Wishlist',
          searchButton: false,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }
  }
  ngOnDestroy(): void {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.layoutService.isMobile$
      .pipe(
        map((isMobile: boolean) => {
          return isMobile;
        }),
        mergeMap((isMobile: boolean) => {
          const wishListProduct = this.productService.getWishlistedProducts(
            10,
            1
          );

          return combineLatest([wishListProduct]);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(([wishListProduct]) => {
        this.wishListProduct = wishListProduct;
        this.loading = false;
      });
  }
}
